import React from "react";

export const wrapPageElement = ({ element }) => element;
